<template>
  <div
    class="c-loading-bar"
    :style="{ height: `${height}px` }"
  >
    <div
      class="c-loading-bar__indicator"
      :class="`c-loading-bar__indicator--${color}`"
    />
  </div>
</template>

<script>
export default {
  name: "BaseLoadingBar",
  props: {
    color: {
      type: String,
      default: "primary",
    },
    height: {
      type: [Number, String],
      default: 4,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-loading-bar {
  overflow: hidden;
  background-color: $secondary;

  &__indicator {
    position: relative;
    width: 100%;
    height: 100%;
    animation: indeterminate 1.8s infinite ease-out;

    &--primary {
      background-color: var(--s-button-bg-primary-default);
    }

    &--secondary {
      background-color: var(--s-button-bg-secondary-default);
    }

    &--warning {
      background-color: var(--s-button-bg-warning-default);
    }

    &--danger {
      background-color: var(--s-button-bg-danger-default);
    }
  }
}

@keyframes indeterminate {
  0% {
    left: -100%;
    width: 100%;
  }

  100% {
    left: 100%;
    width: 10%;
  }
}
</style>
